/** 단답형 퀴즈 채점용 정규화 (앞뒤 공백·연속 공백) */
export function normalizeQuizAnswer(raw: string): string {
  return raw.trim().replace(/\s+/g, ' ');
}

/** `#정답1 #정답2` 형식 — `#`로 구분, 덩어리 내부 띄어쓰기는 유지 */
export function parseQuizCorrectAnswers(correctAnswer: string): string[] {
  const raw = correctAnswer ?? '';
  if (!raw.includes('#')) {
    const single = normalizeQuizAnswer(raw);
    return single ? [single] : [];
  }
  return raw
    .split('#')
    .map((part) => normalizeQuizAnswer(part))
    .filter((part) => part.length > 0);
}

export function getQuizMatchedAnswer(input: string, correctAnswer: string): string | null {
  const normalizedInput = normalizeQuizAnswer(input);
  if (!normalizedInput) return null;
  for (const candidate of parseQuizCorrectAnswers(correctAnswer)) {
    if (normalizedInput === candidate) return candidate;
  }
  return null;
}

export function isQuizAnswerCorrect(input: string, correctAnswer: string): boolean {
  return getQuizMatchedAnswer(input, correctAnswer) != null;
}
